@if (error) {
  <div class="login-callback-error">
    <p>La connexion a échoué / Login failed</p>
    <pre>{{ error }}</pre>
    <button type="button" (click)="retry()">Réessayer / Retry</button>
  </div>
}
